import { postGrowthEngineRecommendationInteraction } from './growthEngineApi'

/** Chip accept/edit passes the item. Primary CTA must not auto-pick a rejected chip. */
export function pickAcceptedSuggestedItem(item) {
  return item && typeof item === 'object' ? item : null
}

export const SUGGESTED_DATA_REJECT_LABEL = "None of these — I'll pick my own"

const suggestedItemMetadata = item => {
  if (!item || typeof item !== 'object') return {}
  return {
    ...(item.productId ? { productId: item.productId } : {}),
    ...(item.title ? { title: item.title } : {}),
    ...(item.purchaseOrderNumber
      ? { purchaseOrderNumber: item.purchaseOrderNumber }
      : {}),
    ...(item.supplierId ? { supplierId: item.supplierId } : {}),
    ...(item.venueSupplierId ? { venueSupplierId: item.venueSupplierId } : {}),
    ...(item.typicalQuantity != null
      ? { typicalQuantity: item.typicalQuantity }
      : {}),
  }
}

/**
 * Post a Guided Success suggested-data / empty-state interaction.
 * Express defaults intentId to `{featureId}_suggested_data` / `_empty_state`.
 */
export async function postGuidedSuccessInteraction(
  venueId,
  { featureId, interaction, metadata = {} } = {},
) {
  if (!venueId || !featureId || !interaction) return null
  return postGrowthEngineRecommendationInteraction(venueId, {
    featureId,
    interaction,
    metadata,
  })
}

export function postSuggestedDataShown(venueId, featureId, items) {
  const list = Array.isArray(items) ? items : []
  if (!list.length) return Promise.resolve(null)
  return postGuidedSuccessInteraction(venueId, {
    featureId,
    interaction: 'suggested_data_shown',
    metadata: { count: list.length },
  })
}

export function postSuggestedDataAccepted(
  venueId,
  featureId,
  item,
  { edit = false } = {},
) {
  return postGuidedSuccessInteraction(venueId, {
    featureId,
    interaction: 'suggested_data_accepted',
    metadata: {
      mode: edit ? 'edit' : 'accept',
      ...suggestedItemMetadata(item),
    },
  })
}

export function postSuggestedDataRejected(venueId, featureId) {
  return postGuidedSuccessInteraction(venueId, {
    featureId,
    interaction: 'suggested_data_rejected',
  })
}

export function postEmptyStateCtaClicked(venueId, featureId) {
  return postGuidedSuccessInteraction(venueId, {
    featureId,
    interaction: 'empty_state_cta_clicked',
  })
}

const warnInteraction = (label, err) => {
  console.warn(`Growth Engine ${label} failed`, err)
}

/**
 * Bind empty-state chip / CTA handlers.
 * Accept and edit start with that item. Reject hides chips. CTA stays manual.
 */
export function bindGuidedEmptySuggestedActions({
  venueId,
  featureId,
  suggested,
  onStart,
} = {}) {
  const start = typeof onStart === 'function' ? onStart : () => {}
  return {
    suggestedItems: suggested?.visibleItems || [],
    onSuggestedItem: item => {
      suggested?.acceptItem?.(item)
      start(item)
    },
    onSuggestedEdit: item => {
      suggested?.acceptItem?.(item, { edit: true })
      start(item)
    },
    onRejectSuggested: () => {
      suggested?.rejectItems?.()
    },
    onCta: () => {
      postEmptyStateCtaClicked(venueId, featureId).catch(err =>
        warnInteraction('empty_state_cta_clicked', err),
      )
      start()
    },
  }
}
